import { useState } from 'react';
import { Users, Gift, CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast } from 'sonner';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    referrer_name: '', referrer_email: '', referrer_phone: '',
    friend_name: '', friend_email: '', friend_phone: '', notes: '',
  });
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.referrer_name || !form.referrer_email || !form.friend_name || !form.friend_email) {
      toast.error(t('carvana.referral.errFill', 'Merci de remplir votre nom, courriel et ceux de votre ami'));
      return;
    }
    try {
      await axios.post(`${API}/referrals`, form);
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1">
        <section className="bg-gradient-to-br from-amber-500 via-orange-500 to-pink-500 text-white py-16 px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Gift className="h-16 w-16 mx-auto mb-4" />
            <h1 className="text-4xl sm:text-5xl font-black mb-3">{t('carvana.referral.title', 'Recommandez un ami, recevez 250$')}</h1>
            <p className="text-lg opacity-95 max-w-xl mx-auto">
              {t('carvana.referral.subtitle', 'Votre ami économise, vous recevez un crédit de 250$ CAD à chaque référence complétée.')}
            </p>
          </div>
        </section>

        <section className="max-w-2xl mx-auto px-4 py-12">
          {done ? (
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center" data-testid="referral-done">
              <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-600 mb-4" />
              <h2 className="text-2xl font-black text-slate-900 mb-2">{t('carvana.referral.thanks', 'Merci!')}</h2>
              <p className="text-slate-600">{t('carvana.referral.doneDesc', 'Nous contacterons votre ami sous peu. Vous recevrez votre crédit de 250$ dès que la vente sera complétée.')}</p>
            </div>
          ) : (
            <form onSubmit={submit} className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 space-y-5" data-testid="referral-form">
              <h2 className="font-bold text-lg text-slate-900 flex items-center gap-2"><Users className="h-5 w-5 text-[#3b82f6]" />{t('carvana.referral.you', 'Vos coordonnées')}</h2>
              <input required placeholder={t('carvana.referral.yourName', 'Votre nom')} value={form.referrer_name} onChange={(e) => setForm({ ...form, referrer_name: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" data-testid="referral-your-name" />
              <input required type="email" placeholder={t('carvana.referral.yourEmail', 'Votre courriel')} value={form.referrer_email} onChange={(e) => setForm({ ...form, referrer_email: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" data-testid="referral-your-email" />
              <input type="tel" placeholder={t('carvana.referral.yourPhone', 'Votre téléphone')} value={form.referrer_phone} onChange={(e) => setForm({ ...form, referrer_phone: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" />

              <h2 className="font-bold text-lg text-slate-900 pt-4 border-t border-slate-100">{t('carvana.referral.friend', 'Votre ami')}</h2>
              <input required placeholder={t('carvana.referral.friendName', 'Nom de l\'ami')} value={form.friend_name} onChange={(e) => setForm({ ...form, friend_name: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" data-testid="referral-friend-name" />
              <input required type="email" placeholder={t('carvana.referral.friendEmail', 'Courriel de l\'ami')} value={form.friend_email} onChange={(e) => setForm({ ...form, friend_email: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" data-testid="referral-friend-email" />
              <input type="tel" placeholder={t('carvana.referral.friendPhone', 'Téléphone (optionnel)')} value={form.friend_phone} onChange={(e) => setForm({ ...form, friend_phone: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" />
              <textarea placeholder={t('carvana.referral.notes', 'Note (optionnel)')} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full border border-slate-300 rounded-lg px-3 py-2.5" rows={3} />

              <button type="submit" className="w-full bg-[#0c2340] text-white font-bold py-4 rounded-xl" data-testid="referral-submit-btn">
                {t('carvana.referral.submit', 'Envoyer la recommandation')}
              </button>
            </form>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
